import _ from 'lodash';
import hasValidRoomTypeCodes from './hasValidRoomTypeCodes';

// using similar logic as the BkFLowRoomCards's render function
export default function hasAvailableRooms(rooms, urlData) {
  if (_.isEmpty(rooms)) return false;

  if (!hasValidRoomTypeCodes(rooms)) {
    return false;
  }

  if (urlData.accessible === 'true') {
    const accessibleRoom = _.find(
      rooms,
      (room) => room.viewExtensions.isAccessible
    );
    if (!accessibleRoom) {
      return false;
    }
  }

  return true;
}



// WEBPACK FOOTER //
// ./src/utilities/content/hasAvailableRooms.js